export const CREATE_USER_ADD_REQUEST = 'CREATE_USER_ADD_REQUEST';
export const CREATE_USER_ADD_SUCCESS = 'CREATE_USER_ADD_SUCCESS';
export const CREATE_USER_ADD_ERROR = 'CREATE_USER_ADD_ERROR';